// extracted by mini-css-extract-plugin
module.exports = {"checksContainer":"styles_checksContainer__3Y3nu","checkContainer":"styles_checkContainer__39jiZ"};